import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { ToastProvider } from './context/ToastContext'
import { SystemConfigProvider } from './context/SystemConfigContext'
import { SchoolAccountProvider } from './context/SchoolAccountContext'
import { ContactProvider } from './context/ContactContext'
import { ProjectProvider } from './context/ProjectContext'
import { DotLoader } from 'react-spinners'

function AppContent() {
  return (
    <SchoolAccountProvider>
      <ContactProvider>
        <ProjectProvider>
          <ToastProvider>
            <Suspense
              fallback={
                <div className="loading-overlay">
                  <DotLoader
                    color="var(--irogami-primary)"
                    size={40}
                    speedMultiplier={1}
                  />
                </div>
              }
            >
              <RouterProvider router={router} future={{ v7_startTransition: true }} />
            </Suspense>
          </ToastProvider>
        </ProjectProvider>
      </ContactProvider>
    </SchoolAccountProvider>
  )
}

function App() {
  return (
    <SystemConfigProvider>
      <AppContent />
    </SystemConfigProvider>
  )
}

export default App

